// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__21Syx","container":"styles_container__1LfqY","title":"styles_title__2fa6a","wrapper":"styles_wrapper__cdxIK","answer":"styles_answer__1Vav0"};